export default {
  title: 'Kosten',
  subtitle: 'Servicekosten-override per restaurant voor {{company}}.',
  card_title: 'Servicekosten',
  banner: {
    default_summary: 'Partnerstandaard: {{percentage}}% · min {{min}} · max {{max}}.',
    override_hint: 'Overschrijf hieronder om andere kosten voor dit restaurant in te stellen.',
    suggested_summary: 'Voorgestelde startwaarden: {{percentage}}% · min. {{min}} · max. {{max}}.',
    suggested_hint: 'Pas ze hieronder aan en sla op om bij dit restaurant servicekosten in rekening te brengen.',
    own_fee_hint: 'Dit restaurant rekent eigen kosten aan, hieronder ingesteld.',
    saved_summary: 'Je laatst opgeslagen waarden: {{percentage}}% · min. {{min}} · max. {{max}}.',
    saved_hint: 'De servicekosten staan uit. Sla deze waarden op, of pas ze eerst aan, om ze weer in te schakelen.',
  },
  form: {
    recommended: 'Aanbevolen: {{value}}',
    percentage: {
      label: 'Servicekosten percentage',
      tooltip: 'Percentage van de bestelwaarde dat als servicekosten aan de klant wordt berekend.',
    },
    min_amount: {
      label: 'Minimumbedrag servicekosten',
      tooltip: 'Berekende kosten onder dit bedrag worden hierop afgerond.',
    },
    max_amount: {
      label: 'Maximumbedrag servicekosten',
      tooltip: 'De servicekosten overschrijden dit bedrag nooit, ongeacht de bestelwaarde.',
    },
  },
  limits:
    'Moet binnen de FoodAmigos-limieten blijven: max {{max_percentage}}% / {{max_amount}}, minimum ten minste {{min_amount}}.',
  not_charged_notice:
    'Bij dit restaurant worden momenteel geen servicekosten in rekening gebracht. Sla hieronder een bedrag op om ze in te schakelen.',
  zero_percentage_warning:
    'Een percentage van 0% schakelt de servicekosten niet uit: berekende kosten onder het minimumbedrag worden hierop afgerond, dus voor elke bestelling wordt ten minste het minimum in rekening gebracht.',
  buttons: {
    edit: 'Bewerken',
    cancel: 'Annuleren',
    save: 'Opslaan',
    reset_to_default: 'Herstellen naar partnerstandaard',
    turn_off: 'Servicekosten uitschakelen',
  },
  toasts: {
    load_error: 'Instellingen voor servicekosten konden niet worden geladen.',
    failed_to_save_changes: 'Wijzigingen opslaan mislukt',
    changes_got_saved: 'Wijzigingen opgeslagen',
    reset_to_default: 'Override verwijderd — de partnerstandaard is van toepassing.',
    reset_to_default_skipped:
      'Overschrijving verwijderd — er wordt geen servicekosten in rekening gebracht totdat je er een opslaat.',
    turned_off: 'Servicekosten uitgeschakeld. Je waarden blijven bewaard voor als je ze weer inschakelt.',
  },
};
